"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BtInstallmentsSelector = BtInstallmentsSelector;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _elements = require("@reservamos/elements");
var _reactI18next = require("react-i18next");
var _BtInstallmentsDialog = require("./BtInstallmentsDialog");
var _BtInstallmentsInline = require("./BtInstallmentsInline");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/** Compose the installment summary and dialog for the active Basis Theory card. */
function BtInstallmentsSelector(_ref) {
  var _plans$months, _plans;
  var cardPreview = _ref.cardPreview,
    _ref$eligibilityFeedb = _ref.eligibilityFeedback,
    eligibilityFeedback = _ref$eligibilityFeedb === void 0 ? 'checking' : _ref$eligibilityFeedb,
    eligibilityStatus = _ref.eligibilityStatus,
    plans = _ref.plans,
    retryEligibility = _ref.retryEligibility,
    selectMonths = _ref.selectMonths,
    selectSinglePayment = _ref.selectSinglePayment,
    selectedMonths = _ref.selectedMonths,
    selectedPlan = _ref.selectedPlan,
    showInterest = _ref.showInterest,
    shouldRender = _ref.shouldRender,
    totalAmount = _ref.totalAmount;
  var _useTranslation = (0, _reactI18next.useTranslation)('purchase'),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isDialogOpen = _useState2[0],
    setIsDialogOpen = _useState2[1];
  var selectorRef = (0, _react.useRef)(null);
  var openDialog = (0, _react.useCallback)(function () {
    return setIsDialogOpen(true);
  }, []);
  var closeDialog = (0, _react.useCallback)(function () {
    return setIsDialogOpen(false);
  }, []);
  (0, _react.useEffect)(function () {
    var _selectorRef$current;
    if (eligibilityStatus !== 'eligible' || typeof window.matchMedia !== 'function') return;
    var isMobile = window.matchMedia('(max-width: 640px)').matches;
    if (!isMobile) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 || _selectorRef$current.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'center'
    });
  }, [eligibilityStatus]);
  if (!shouldRender) return null;
  if (eligibilityStatus === 'checking') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: selectorRef,
      className: "mx-4 mt-2 flex items-center gap-2 rounded-xl border border-gray-200 bg-gray-100 px-[14px] py-[10px] md:mx-5",
      "aria-live": "polite"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "h-4 w-4 animate-spin rounded-full border-2 border-gray-200 border-t-accent-regular",
      "aria-hidden": "true"
    }), /*#__PURE__*/_react["default"].createElement(_elements.Text, {
      size: "XS",
      color: "grayMedium"
    }, t("bt_installments.".concat(eligibilityFeedback))));
  }
  if (eligibilityStatus === 'error') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: selectorRef,
      className: "mx-4 mt-2 flex items-center justify-between gap-3 rounded-xl border border-gray-200 bg-gray-100 px-[14px] py-[10px] md:mx-5",
      role: "status"
    }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
      size: "XS",
      color: "grayStrong"
    }, t('bt_installments.validation_error')), /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "text-sm font-semibold text-accent-regular underline",
      onClick: retryEligibility
    }, t('saved_card.retry')));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: selectorRef,
    className: "mx-4 mt-2 flex flex-col gap-2 md:mx-5",
    "data-sentry-component": "BtInstallmentsSelector",
    "data-sentry-source-file": "BtInstallmentsSelector.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col gap-4 pb-3"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "M",
    weight: "semibold",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "BtInstallmentsSelector.tsx"
  }, t('bt_installments.title')), /*#__PURE__*/_react["default"].createElement(_BtInstallmentsInline.BtInstallmentsInline, {
    totalAmount: totalAmount,
    maxMonths: (_plans$months = (_plans = plans[plans.length - 1]) === null || _plans === void 0 ? void 0 : _plans.months) !== null && _plans$months !== void 0 ? _plans$months : 0,
    selectedMonths: selectedMonths,
    selectedPlan: selectedPlan,
    onOpen: openDialog,
    "data-sentry-element": "BtInstallmentsInline",
    "data-sentry-source-file": "BtInstallmentsSelector.tsx"
  })), /*#__PURE__*/_react["default"].createElement(_BtInstallmentsDialog.BtInstallmentsDialog, {
    cardPreview: cardPreview,
    isOpen: isDialogOpen,
    totalAmount: totalAmount,
    selectedMonths: selectedMonths,
    plans: plans,
    showInterest: showInterest,
    onSelectMonths: selectMonths,
    onSelectSingle: selectSinglePayment,
    onClose: closeDialog,
    "data-sentry-element": "BtInstallmentsDialog",
    "data-sentry-source-file": "BtInstallmentsSelector.tsx"
  }));
}